import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./App";

const domElement = document.getElementById('root');
const domLanguage = document.documentElement.lang;
const root = ReactDOM.createRoot(domElement);
// const devBaseUri = 'https://soulsteps.dockyard.local';

async function fetchData() {
    const response = await fetch('/' + domLanguage + '/questionnaire/api/get/' + domElement.dataset.endpoint + '/' + domElement.dataset.questionnaire);
    // const response = await fetch(devBaseUri + '/' + domLanguage + '/questionnaire/api/get/fragebogen');
    const metadata = await response.json();
    root.render(
        <React.StrictMode>
            <App metadata={metadata} questionnaireId={domElement.dataset.questionnaire} />
        </React.StrictMode>
    );
}
fetchData();
